module.exports = "https://static.energy5.com/_next/static/images/intuitiveNavigationImage-21430090dea6da72461850bd8d00db2f.jpg";